'use client';

import Link from 'next/link';

import { Button } from '@eliadmin/core/src/components/ui/button';
import { Heading } from '@eliadmin/core/src/components/ui/heading';
import { Paragraph } from '@eliadmin/core/src/components/ui/paragraph';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useBreakpoint } from '@eliadmin/core/src/hooks/use-breakpoint';
import { LuX } from 'react-icons/lu';

export interface ReservationFormHeaderProps {
  step: number;
  totalSteps: number;
  title: string;
  description: string;
}

export function ReservationFormHeader({
  step,
  totalSteps,
  title,
  description,
}: ReservationFormHeaderProps) {
  const isDesktop = useBreakpoint('sm');

  return (
    <div className="relative flex w-full flex-col items-center justify-center gap-3 sm:gap-4 lg:gap-6">
      <Button
        asChild
        variant="outline"
        size={isDesktop ? 'icon' : 'icon-md'}
        className="absolute right-0 top-0 z-10"
      >
        <Link href={ROUTES.HOME()}>
          <LuX size={18} className="text-secondary" />
        </Link>
      </Button>
      <p className="text-base font-bold text-secondary sm:text-lg">
        Krok {step} z {totalSteps}
      </p>
      <Heading center tag="h3" title={title} />
      <Paragraph className="w-full text-center" size="lg">
        {description}
      </Paragraph>
    </div>
  );
}
